import * as React from 'react';
import {IMask, IMaskInput} from 'react-imask';


interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const DateInput = React.forwardRef<HTMLElement, CustomProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="m/d/Y"
        eager
        lazy={false}
        blocks={{
          d: {mask: IMask.MaskedRange, placeholderChar: 'd', from: 1, to: 31, maxLength: 2, autofix:'pad'},
          m: {mask: IMask.MaskedRange, placeholderChar: 'm', from: 1, to: 12, maxLength: 2, autofix: 'pad'},
          Y: {mask: IMask.MaskedRange, placeholderChar: 'y', from: 1900, to: 2999, maxLength: 4, autofix:false}
        }}
        definitions={{
          '#': /[1-9]/,
        }}
        // @ts-ignore
        inputRef={ref}
        onAccept={(unmaskedValue: any) => onChange({ target: { name: props.name, value: unmaskedValue } })}
      />
    );
  },
);

export default DateInput;